module.exports = __webpack_public_path__ + "fonts/s2l.5471c43.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/s2l.woff?1k5k71
// module id = 1106
// module chunks = 0